import { render, staticRenderFns } from "./VipPrice.vue?vue&type=template&id=e9ff6ed6&scoped=true&"
import script from "./VipPrice.vue?vue&type=script&lang=js&"
export * from "./VipPrice.vue?vue&type=script&lang=js&"
import style0 from "./VipPrice.vue?vue&type=style&index=0&id=e9ff6ed6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ff6ed6",
  null
  
)

export default component.exports